export default __webpack_public_path__ + "static/media/eye.07b9d2b2.svg";